/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const OpenMode = {
  NEW: 'NEW',
  VIEW: 'VIEW',
  EDIT: 'EDIT',
};
